<!--
Emitted events:
- removed
-->
<template>
  <div class="file" :title="label" @click="download">
    <div class="thumbnail">
      <FontAwesomeIcon
        class="file-icon"
        :icon="removing ? $icons.spinner : $icons.file"
        :spin="removing"
      />
      <div v-if="removable" class="remove-icon" @click.stop="remove">
        <FontAwesomeIcon :icon="$icons.trashOutlined" />
      </div>
    </div>
    <div class="label">
      <slot />
    </div>
  </div>
</template>

<script>
  import Files from '../../../api/files';
  import download from 'downloadjs';

  export default {
    name: 'File',
    props: {
      id: {
        type: String,
        required: true,
      },
      removable: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        removing: false,
      };
    },
    computed: {
      label() {
        if (!this.$slots.default[0] || !this.$slots.default[0].text) {
          return;
        }

        return this.$slots.default[0].text.trim();
      },
    },
    methods: {
      async download() {
        if(!this.id) {
          return;
        }

        try {
          const file = await Files.download(this.id);
          download(file, this.label);
        } catch (e) {
          this.$addError(this.$t('file.errors.download'));
          throw e;
        }
      },
      async remove() {
        try {
          this.removing = true;
          await Files.remove(this.id);
          this.$emit('removed');
        } catch (e) {
          this.$addError(this.$t('file.errors.remove'));
          throw e;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .file {
    cursor: pointer;
    margin: 1rem 1rem 0;
  }

  .thumbnail {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 12rem;
    height: 9rem;
    background-color: white;
    border: 1px solid #E0E0E0;
    border-radius: 0.5rem;
  }

  .remove-icon {
    position: absolute;
    right: -0.5rem;
    bottom: -0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $errorColor;
    color: $lightTextColor;
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 0.3rem;
    cursor: pointer;
  }

  .label {
    text-align: center;
    margin-top: 1rem;
    max-width: 12rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .file-icon {
    font-size: 4rem;
    color: #E0E0E0;
  }
</style>
